<template>
  <div class="parcel">
    <div class="weui-cells">
      <div class="weui-cell weui-cell_select weui-cell_select-after bigfontsize">
          <div class="weui-cell__hd bg1">
              <label class="weui-label">门店选择</label>
          </div>
          <div @click="chooseAdd" class="weui-cell__bd">
              <div v-for="(v,k) in addList" v-bind:key="k" v-if="v.id==add_id">{{v.address}}</div>
              <!-- <select v-model="add_id" class="weui-select" name="select2" @change="chooseAdd()">
                  <option v-for="(v,k) in addList" v-bind:key="k" :value="v.id">{{v.address}}</option>
              </select> -->
          </div>
      </div>
      <div class="weui-cell weui-cell_select weui-cell_select-after">
          <div class="weui-cell__hd bg2">
              <label class="weui-label">服务商</label>
          </div>
          <div @click="chooseService" class="weui-cell__bd">
            <div v-for="(v,k) in serviceList" v-bind:key="k" v-if="v.id==service_id">{{v.title}}</div>
              <!-- <select v-model="service_id" class="weui-select" name="select2">
                  <option v-for="(v,k) in serviceList" v-bind:key="k" :value="v.id">{{v.title}}</option>
              </select> -->
          </div>
      </div>
      <!-- <div class="weui-cell weui-cell_select weui-cell_select-after">
          <div class="weui-cell__hd bg2">
              <label class="weui-label">服务商</label>
          </div>
          <div class="weui-cell__bd">
              <select v-model="service_id" class="weui-select" name="select2">
                  <option v-for="(v,k) in serviceList" v-bind:key="k" :value="v.id">{{v.title}}</option>
              </select>
          </div>
      </div> -->
    </div>
    <div class="weui-cells__title topline">取件信息</div>
    <div class="weui-cells textareabox">
      <div class="weui-cell">
          <div class="weui-cell__bd">
              <textarea v-model="note" class="weui-textarea" placeholder="请填写取件信息" rows="4"></textarea>
          </div>
      </div>
    </div>

    <div class="app-btn-area weui-btn-area">
        <div @click="submit" class="weui-btn">确认</div>
    </div>
    <!-- {{info.add_id}} -->

    <div id="singleLinePicker"></div>
    <div id="singleLinePicker2"></div>
  </div>
</template>
<style>
.weui-picker{
  user-select:none;
  font-size: 16px;
}
</style>

<script>
import weui from 'weui.js'
export default {
  data(){
    return{
      addList:[],
      add_id:'',
      serviceList:[],
      service_id:'',
      note:'',
      info:''
    }
  },
  mounted(){
    let info = localStorage.getItem('info');
    if(info){
      try {
        info = JSON.parse(info);
        // console.log(info);
        this.info = info
      } catch (error) {

      }
    }
    this.getAccount();
    this.getAddress()
  },
  methods: {
    getAccount(){
      let vm = this;
      vm.ajax("account", "get", '', e => {
        vm.account = e.data;
      })
    },
    getAddress(){
      let vm = this;
      vm.ajax("address", "get", '', e => {
        vm.addList = e.data
        if(vm.addList && vm.addList.length>0){
          vm.addList.map((item,index)=>{
            item.label=item.address
            item.value=item.id
          })
          vm.add_id = vm.addList[0].id
          vm.getService()
        }
      })
    },
    chooseAdd(){
      let vm = this;
      weui.picker(vm.addList, {
          className: 'custom-classname',
          container: 'body',
          defaultValue: [vm.add_id],
          // onChange: function (result) {
          //     console.log('onChange',result)
          // },
          onConfirm: function (result) {
              // console.log('onConfirm',result)
              vm.add_id = result[0].id
              vm.getService()
          },
          id: 'singleLinePicker'
        });
    },
    chooseService(){
      let vm = this;
      weui.picker(vm.serviceList, {
          className: 'custom-classname',
          container: 'body',
          defaultValue: [vm.service_id],
          // onChange: function (result) {
          //     console.log('onChange',result)
          // },
          onConfirm: function (result) {
              // console.log('onConfirm',result)
              vm.service_id = result[0].id
          },
          id: 'singleLinePicker2'
        });
    },
    // chooseAdd(){
    //   this.getService()
    // },
    getService(){
      let vm = this;
      vm.ajax("service", "get", 'addid='+vm.add_id, e => {
        vm.serviceList = e.data
        if(vm.serviceList && vm.serviceList.length>0){
          vm.serviceList.map((item,index)=>{
            item.label=item.title
            item.value=item.id
          })
          vm.service_id = vm.serviceList[0].id
        }
      })
    },
    submit(){
      let vm = this;
      let info = {
        add_id:vm.add_id,
        service_id:vm.service_id,
        note:vm.note
      }
      localStorage.setItem('info', JSON.stringify(info));
      if( !(vm.add_id > 0)){
        vm.publics.message.danger('请选择门店');
        return false;
      }
      if( !(vm.service_id > 0)){
        vm.publics.message.danger('请选择服务商');
        return false;
      }
      if(!vm.note){
        vm.publics.message.danger('请输入取件信息');
        return false;
      }
      vm.ajax("account/parcel", "post", {
        add_id:vm.add_id,
        service_id:vm.service_id,
        note:vm.note
      }, e => {
        vm.publics.message.success('寄件信息提交成功');
        vm.$router.go(-1)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/parcel.vue